import { isDiscoverySearched } from 'types/creator-discovery';

interface DiscoveryStatusBannerProps {
    state: string;
    creatorsCount?: number;
}

const PROCESSING_STEPS = [
    {
        states: ['queued'],
        label: 'Getting started',
        description: 'We have received your search and are getting things ready.',
    },
    {
        states: ['analysed', 'analyzed'],
        label: 'Reviewing creators',
        description: 'Our AI is looking through profiles that match your brief.',
    },
    {
        states: ['classified'],
        label: 'Ranking matches',
        description: 'We are putting the best creators at the top for you.',
    },
] as const;

const DEFAULT_PROCESSING = {
    label: 'Finding creators',
    description: 'This usually takes a moment. Please hang tight.',
};

const getProcessingStep = (state: string) => {
    const normalized = state.toLowerCase();
    return PROCESSING_STEPS.find((step) => step.states.some((key) => key === normalized)) ?? DEFAULT_PROCESSING;
};

const getActiveStepIndex = (state: string) => {
    const normalized = state.toLowerCase();
    const index = PROCESSING_STEPS.findIndex((step) => step.states.some((key) => key === normalized));
    return index === -1 ? 0 : index;
};

const DiscoveryStatusBanner = ({ state, creatorsCount }: DiscoveryStatusBannerProps) => {
    const isReady = isDiscoverySearched(state);
    const processing = getProcessingStep(state);
    const activeStepIndex = getActiveStepIndex(state);

    if (isReady) {
        return (
            <div className="discovery-status-banner discovery-status-banner--ready">
                <div className="discovery-status-banner__icon-wrap">
                    <i className="ri-checkbox-circle-line" />
                </div>
                <div className="discovery-status-banner__text">
                    <div className="discovery-status-banner__label-row">
                        <span className="discovery-status-banner__label">Results ready</span>
                        {creatorsCount !== undefined && (
                            <span className="discovery-status-banner__count">{creatorsCount} creators</span>
                        )}
                    </div>
                    <p className="discovery-status-banner__description">
                        Your search completed successfully. Browse the matched creators below.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="discovery-status-banner discovery-status-banner--processing">
            <div className="discovery-status-banner__icon-wrap">
                <div className="discovery-status-banner__spinner">
                    <i className="ri-loader-4-line" />
                </div>
            </div>
            <div className="discovery-status-banner__text">
                <div className="discovery-status-banner__label-row">
                    <span className="discovery-status-banner__label">{processing.label}</span>
                </div>
                <p className="discovery-status-banner__description">{processing.description}</p>
            </div>
        </div>
    );
};

export default DiscoveryStatusBanner;
